import List from './List';

const Reports = {
  List
};

export default Reports;
